import { Breadcrumbs, NoRecordFoundV2 } from "components/Common/Common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { Col, Container, Row } from "react-bootstrap";

import styles from './profile.module.scss';
import LoadingOverlay from "components/shared/LoadingOverlay";
import { useGetMySchoolDataQuery } from "store/services/V2/profile";

const MySchools = () => {
  const { data: schoolDetails, isLoading: schoolDetailsLoading, isFetching: schoolDetailsFetching } = useGetMySchoolDataQuery();

  return (
    <>
      <div className="px-3 py-2">
        <Breadcrumbs items={[{ label: "Profile", path: "/profile" }, { label: "My Schools", path: "" }]} style={{ fontSize: "14px" }} />
        <section className={`${styles.addForm} position-relative col-lg-10 addForm`}>
          <Container fluid={true}>
            {(schoolDetailsLoading) ? <LoadingIndicator /> :
              <Row>
                {(schoolDetailsFetching) && <LoadingOverlay />}

                <div className="px-0">
                  <Col lg="12" className="my-2">
                    <div style={{ borderBottom: '0.75px solid #93278F', paddingBottom: "11px" }} className=' d-flex align-items-end justify-content-between'>
                      <h5 className='section-title-main fw-medium border-0 mt-4 mb-0 p-0'>My Schools</h5>
                    </div>
                    <h5 style={{ marginTop: "16px" }} className="section-title">SCHOOL LIST FOR CLASSROOM REPORTS</h5>
                  </Col>
                  {
                    schoolDetails?.length ? schoolDetails?.map((item) => {
                      return (
                        <Row className="mb-4">
                          <Col xs="6" md='4'>
                            <label className="discharge-screen-label">School Divisions</label><br />
                            <p className="discharge-screen-sub-label mb-0" style={{ fontFamily: "Proxima Nova" }}>{item?.division_name}</p>
                          </Col>
                          <Col xs="6" md='4'>
                            <label className="discharge-screen-label">Schools</label><br />
                            {
                              item?.schools?.map((list) => (
                                <p className="discharge-screen-sub-label mb-0" style={{ fontFamily: "Proxima Nova" }}>{list?.name}</p>
                              ))
                            }
                          </Col>
                        </Row>
                      )
                    }) : <NoRecordFoundV2 />
                  }

                </div>
              </Row>}
          </Container>
        </section>
      </div>
    </>
  );
};

export default MySchools;